import { pino } from 'pino';

export const logger = pino({
  level: 'info',
  transport: {
    target: 'pino-pretty',
    options: {
      colorize: true,
    },
  },
});

// Export logger instance
export default logger;

// Utility functions for structured logging
export function createChildLogger(name: string) {
  return logger.child({ name });
}

export function setLogLevel(level: string) {
  logger.level = level;
}

export function getLogLevel() {
  return logger.level;
}
